
/*========================================
        Imports!!!
=========================================*/

/*--BrowserRouter--*/

import { Link, useNavigate } from 'react-router';
import { useState } from 'react';

/*--css--*/
import '../assets/css/gallery.css';
import '../assets/css/staticElements.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';



/*--cows footer--*/

import mu1 from '../assets/cowsss/lower/3.webp';
import mu2 from '../assets/cowsss/lower/5.webp';
import mu3 from '../assets/cowsss/lower/6.webp';
import mu4 from '../assets/cowsss/lower/7.webp';
import mu5 from '../assets/cowsss/lower/4.webp';
import mu6 from '../assets/cowsss/lower/1.webp';
import social2 from '../assets/icons/phone.webp';
import social3 from '../assets/icons/insta.webp';



/*--Gallery images--*/

import cows1 from '../assets/gallery/lower/cows1.webp';
import cows2 from '../assets/gallery/lower/cows2.webp';
import cows3 from '../assets/gallery/lower/cows3.webp';
import cows4 from '../assets/gallery/lower/cows4.webp';
import cows5 from '../assets/gallery/lower/cows5.webp';
import cows6 from '../assets/gallery/lower/cows6.webp';
import cows7 from '../assets/gallery/lower/cows7.webp';
import cows8 from '../assets/gallery/lower/cows8.webp';
import cows9 from '../assets/gallery/lower/cows9.webp';
import cows10 from '../assets/gallery/lower/cows10.webp';
import cows11 from '../assets/gallery/lower/cows11.webp';
import cows12 from '../assets/gallery/lower/cows12.webp';
import cows13 from '../assets/gallery/lower/cows13.webp';
import cows14 from '../assets/gallery/lower/cows14.webp';
import cows15 from '../assets/gallery/lower/cows15.webp';
import cows16 from '../assets/gallery/lower/cows16.webp';
import cows17 from '../assets/gallery/lower/cows17.webp';
import cows18 from '../assets/gallery/lower/cows18.webp';
import cows19 from '../assets/gallery/lower/cows19.webp';
import cows20 from '../assets/gallery/lower/cows20.webp';
import cows21 from '../assets/gallery/lower/cows21.webp';

import movie1 from '../assets/gallery/movie1.webm';
import movie2 from '../assets/gallery/movie2.webm';
import movie3 from '../assets/gallery/movie3.webm';
import movie4 from '../assets/gallery/movie4.webm';
import movie5 from '../assets/gallery/movie5.mp4';
import movie6 from '../assets/gallery/movie6.webm';
import movie7 from '../assets/gallery/movie7.webm';

import movie11 from '../assets/gallery/movie1.mp4';
import movie12 from '../assets/gallery/movie2.mp4';
import movie13 from '../assets/gallery/movie3.mp4';
import movie14 from '../assets/gallery/movie4.mp4';
import movie16 from '../assets/gallery/movie6.mp4';
import movie17 from '../assets/gallery/movie7.mp4';

/*--logo--*/
import logo from '../assets/img/logo.webp';

/*--higher versions--*/

/*--cows footer--*/

import mu1h from '../assets/cowsss/higher/3.webp';
import mu2h from '../assets/cowsss/higher/5.webp';
import mu3h from '../assets/cowsss/higher/6.webp';
import mu4h from '../assets/cowsss/higher/7.webp';
import mu5h from '../assets/cowsss/higher/4.webp';
import mu6h from '../assets/cowsss/higher/1.webp';


/*--Gallery images--*/

import cows6h from '../assets/gallery/higher/cows6.webp';
import cows7h from '../assets/gallery/higher/cows7.webp';
import cows12h from '../assets/gallery/higher/cows12.webp';
import cows13h from '../assets/gallery/higher/cows13.webp';
import cows18h from '../assets/gallery/higher/cows18.webp';
import cows20h from '../assets/gallery/higher/cows20.webp';
import cows21h from '../assets/gallery/higher/cows21.webp';

/*========================================
        Functions!!!
=========================================*/

function Gallery({Changing2}) {
    return (
        <>
            <article className='GalleryContainer'>
                <section className='GalleryContent'>
                    <Row className='cytat'>
                        <h1>Beskidzkie Stado ujęte w kadrze</h1>
                        <i>"W oczach zwierząt można zobaczyć to, co najprawdziwsze... naturę bez słów."</i>
                    </Row>
                    <Row>
                        <Col lg={4} md={4} sm={12}>
                            <img onLoad={Changing2} src={cows1} alt='cows' id="cows1"/>
                            <img onLoad={Changing2} src={cows2} alt='cows' id="cows2"/>
                            <video autoPlay loop muted playsInline>
                                <source src={movie1} type="video/webm" />
                                <source src={movie11} type="video/mp4" />     
                            </video>
                            <img onLoad={Changing2} src={cows3} alt='cows' id="cows3"/>
                            <img onLoad={Changing2} src={cows4} alt='cows' id="cows4"/>
                            <video autoPlay loop muted playsInline>
                                <source src={movie6} type="video/webm" />
                                <source src={movie16} type="video/mp4" />     
                            </video>
                            <img src={cows5} alt='cows' id="cows5"/>
                            <video autoPlay loop muted playsInline>
                                <source src={movie4} type="video/webm" />
                                <source src={movie14} type="video/mp4" />     
                            </video>
                            <img onLoad={Changing2} src={cows6} alt='cows' id="cows6"/>
                            <img onLoad={Changing2} src={cows7} alt='cows' id="cows7"/>
                        </Col>

                        <Col lg={4} md={4} sm={12}>
                            <img onLoad={Changing2} src={cows8} alt='cows' id="cows8"/>
                            <img onLoad={Changing2} src={cows9} alt='cows' id="cows9"/>
                            <img onLoad={Changing2} src={cows10} alt='cows' id="cows10"/>
                            <video autoPlay loop muted playsInline>
                                <source src={movie3} type="video/webm" />
                                <source src={movie13} type="video/mp4" />     
                            </video>
                            <img onLoad={Changing2} src={cows11} alt='cows' id="cows11"/>
                            <img onLoad={Changing2} src={cows12} alt='cows' id="cows12"/>
                            <img onLoad={Changing2} src={cows14} alt='cows' id="cows14"/>
                            <img onLoad={Changing2} src={cows13} alt='cows' id="cows13"/>
                            <img onLoad={Changing2} src={cows20} alt='cows' id="cows20"/>
                            <img onLoad={Changing2} src={cows21} alt='cows' id="cows21"/>
                        </Col>

                        <Col lg={4} md={4} sm={12}>
                            <img onLoad={Changing2} src={cows15} alt='cows' id="cows15"/>
                            <video autoPlay loop muted playsInline>
                                <source src={movie7} type="video/webm" />
                                <source src={movie17} type="video/mp4" />     
                            </video>
                            <img onLoad={Changing2} src={cows16} alt='cows' id="cows16"/>
                            <img onLoad={Changing2} src={cows17} alt='cows' id="cows17"/>
                            <img onLoad={Changing2} src={cows18} alt='cows' id="cows18"/>
                            <video autoPlay loop muted playsInline>
                                <source src={movie5} type="video/mp4" />     
                            </video>
                            <img onLoad={Changing2} src={cows19} alt='cows' id="cows19"/>
                            <video autoPlay loop muted playsInline>
                                <source src={movie2} type="video/webm" />
                                <source src={movie12} type="video/mp4" />     
                            </video>
                        </Col>
                    </Row>
                </section>
            </article>  
        </>
    );
}


/*========================================
        Functions!!!
=========================================*/

function LinkToContact() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
    navigate('/#Contact');
  };

  return (
    <button onClick={handleClick}>O nas</button>
  );
}

function LinkToProducts() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
    navigate('/#Products');
  };

  return (
    <button onClick={handleClick}>Produkty</button>
  );
}

/*========================================
        Header!!!
=========================================*/

function Header(){
  return (
    <>
    {/*====Header====*/}
    <header>
      <Row className='p-4'>
        {/*----Logo----*/}
        <Col xl={8} lg={7} md={6}>
          <div className='Logo'>
              <Link to="/" reloadDocument={true}>
                <Row>
                  <Col lg={1} md={2} xs={2} className='log'>
                    <img src={logo} alt='logo' />
                  </Col>
                  <Col  lg={10} md={9} xs={9} className='log textlog'>
                    Beskidzkie Stado
                  </Col>
                </Row>
              </Link>
          </div>
        </Col>
        {/*----Tabs----*/}
        <Col xl={4} lg={5} md={6} className='log'>
          <Row className='Tabs'>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#About' >
                <LinkToContact />
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#Products'>
                <LinkToProducts />
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#Contact'>
                <button>Kontakt</button>
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
                <Link to="/blog" reloadDocument = {true}>
                  <button>Blog</button>
                </Link>
            </Col>
          </Row>
        </Col>
      </Row>
      </header >
    </>
  );
}



/*========------------========*/
/*========------------========*/
/*------Footer------*/
/*========------------========*/
/*========------------========*/

function Footer({Changing2}) {
  return (
    <>
      <section className='footer'>
        <Row className='MiniGallery'>
          {/*-short gallery-*/}
          <Col lg={6} md={12} xs={12} className='mincol'>
            <section className='stadko'>
              {/*-logo-*/}
              <div className='FooterLogo'>
                <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                  <Row>
                    <Col lg={2} md={1} xs={2} className='logoFooter'>
                      <p>
                        <img src={logo} alt='logo' />
                      </p>
                    </Col>
                    <Col lg={10} md={11} xs={10} className='logoFooter'>
                      <h2>Beskidzkie Stado</h2>
                    </Col>
                  </Row>
                </a>
              </div>
              {/*-photos-*/}
              <div className='smallGallery'>
                <Row>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing2} src={mu6} alt="Cow" id="mu6"/>
                    </a>  
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing2} src={mu4} alt="Cow" id="mu4"/>
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing2} src={mu3} alt="Cow" id="mu3"/>
                    </a>
                  </Col>
                </Row>
                <Row className='tooff'>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing2} src={mu2} alt="Cow" id="mu2"/>
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing2} src={mu5} alt="Cow" id="mu5"/>
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing2} src={mu1} alt="Cow" id="mu1"/>
                    </a>
                  </Col>
                </Row>
              </div>
            </section>
          </Col>
          {/*-Contact-*/}
          <Col lg={6} md={12} xs={12}  className='mincol'>
              <section className='contact' id='Contact'>
                <div>
                  <h2>Kontakt</h2>
                </div>
                <section className='links'>
                  {/*-phone-*/}
                  <Row className='package'>
                    <Col lg={2} md={12} xs={12} className='Colek'>
                      <a href='tel:+48 532 233 916'>
                        <img src={social2} alt="socialek" loading="lazy" />
                      </a>
                    </Col>
                    <Col lg={9} md={12} xs={12} className='Colek'>
                      <span>+48 532 233 916</span>
                    </Col>
                  </Row>
                  {/*-instagram-*/}
                  <Row className='package'>
                    <Col lg={2} md={12} xs={12} className='Colek'>
                      <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                        <img src={social3} alt="socialek" loading="lazy" />
                      </a>
                    </Col>
                    <Col lg={9} md={12} xs={12} className='Colek'>
                      <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                        <span>Beskidzkie_stado</span>
                      </a>
                    </Col>
                  </Row>
                </section>
            </section>
          </Col>
        </Row>
        {/*-Copyright-*/}
        <Row>
          <Col lg={12} md={12} xs={12} className='copyright'>
            <div className='copya'>All rights reserved. Created by <a href="https://pixelpick.pl"> PixelPick</a></div>
          </Col>
        </Row>
      </section>
    </>
  );
}


function Album() {
  const [loadedCount2, setLoadedCount2] = useState(null);
  
  const Changing2 = () => {
    setLoadedCount2(prev => {
      const newCount2 = prev + 1;
      if (newCount2 === 22) {
        console.log("Photos loaded!");
        setTimeout(() => {
          console.log("Iaam loading better quality photos now");
  
          const safeSetSrc = (id, src) => {
            const el = document.getElementById(id);
            if (el) el.src = src;
            else console.warn(`Element ${id} nie znaleziony.`);
          };

          safeSetSrc("cows5", cows5);
          safeSetSrc("cows6", cows6h);
          safeSetSrc("cows7", cows7h);
          safeSetSrc("cows12", cows12h);
          safeSetSrc("cows13", cows13h);
          safeSetSrc("cows20", cows20h);
          safeSetSrc("cows21", cows21h);
          safeSetSrc("cows18", cows18h);
          safeSetSrc("mu1", mu1h);
          safeSetSrc("mu2", mu2h);
          safeSetSrc("mu3", mu3h);
          safeSetSrc("mu4", mu4h);
          safeSetSrc("mu5", mu5h);
          safeSetSrc("mu6", mu6h);
  
        }, 2000);
        console.log(loadedCount2);
      }
      return newCount2;
    });
  }


    return (
        <>
          <Header />
          <Gallery Changing2={Changing2}/>
          <Footer Changing2={Changing2}/>
        </>
    ); 
}



export default Album;